import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Surface read-only / subscription-required errors once, globally.
let lastLockToastAt = 0;
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 402) {
      const now = Date.now();
      if (now - lastLockToastAt > 3000) {
        lastLockToastAt = now;
        toast.error("Subscription required to make changes.", {
          description: "Your workspace is in read-only mode. Open Settings → Billing to subscribe.",
          action: {
            label: "Open Billing",
            onClick: () => {
              window.location.assign("/settings/billing");
            },
          },
        });
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
